import { useQuery } from "@tanstack/react-query";
import { OrganizationType } from "@platform/types/orgInvitation.types";
import { validateOrgInvitation } from "../utils/validateOrgInvitation";

export function useValidateOrgLookupItem(
  organization: OrganizationType | null
) {
  const query = useQuery({
    queryKey: ["validate-org", organization?.organization_id],

    queryFn: async () => {
      if (!organization) throw new Error("No organization provided");

      return validateOrgInvitation({ organization, type: "lookupOrg" });
    },

    // Prevent query from running when no org is selected
    enabled: !!organization,

    // Disable retry to avoid repeated failures
    retry: false,
  });

  const isValid = query.isSuccess;

  return {
    ...query,
    isValid,
  };
}
